module.exports = __webpack_public_path__ + "static/img/bg-en.67f12d94.png";